export default __webpack_public_path__ + "static/media/WashStudioStep1.f7ce10ab.png";